'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = truffleTransform;
function truffleTransform() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$abi = _ref.abi,
      abi = _ref$abi === undefined ? [] : _ref$abi,
      bytecode = _ref.bytecode,
      _ref$networks = _ref.networks,
      networks = _ref$networks === undefined ? {} : _ref$networks;

  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      network = _ref2.network;

  var address = void 0;

  // Some clients (like Ganache) create IDs as integers; normalise them
  var networkKeys = Object.keys(networks).map(function (id) {
    return '' + id;
  });

  if (network && networkKeys.length) {
    if (!networks[network]) throw new Error('Network ID ' + network + ' not found in contract');
    address = networks[network].address;
  } else {
    var _ref3 = networks[networkKeys[networkKeys.length - 1]] || {};
    // Pick the last network (assumed to be the most recent)


    address = _ref3.address;
  }

  return {
    abi: abi,
    address: address,
    bytecode: bytecode
  };
}
//# sourceMappingURL=truffleTransform.js.map